import { getFullAddress } from 'util/recipientsToLetters'

export type Recipient = {
	email?: string
	displayName?: string
	phoneNumber?: string
	address?: string
	digitalDeliveryConsents?: Record<string, boolean>
}

const getIndexOfRecipient = (haystack: Recipient[], needle: Recipient) => {
	for (let i = 0; i < haystack.length; ++i) {
		const current = haystack[i]
		if (needle.email && needle.email === current.email) {
			return i
		}

		if (
			needle.address &&
			getFullAddress(current) === getFullAddress(needle) &&
			needle.displayName &&
			current.displayName === needle.displayName
		) {
			return i
		}

		if (needle.phoneNumber && needle.phoneNumber === current.phoneNumber) {
			return i
		}
	}
	return -1
}

const mergeRecipient = (current_: Recipient, importing: Recipient) => {
	// If we import from many sources, merge the data we can

	const current = { ...current_ }

	// digital delivery consents
	if (importing.digitalDeliveryConsents && current.digitalDeliveryConsents) {
		for (const key of Object.keys(importing.digitalDeliveryConsents)) {
			if (
				!current.digitalDeliveryConsents[key] &&
				importing.digitalDeliveryConsents[key]
			) {
				current.digitalDeliveryConsents[key] = true
			}
		}
	}

	// address
	if (
		importing.email &&
		importing.address &&
		current.email &&
		!current.address &&
		current.email === importing.email
	) {
		current.address = importing.address
	}
	if (
		importing.phoneNumber &&
		importing.address &&
		current.phoneNumber &&
		!current.address &&
		current.phoneNumber === importing.phoneNumber
	) {
		current.address = importing.address
	}

	// email
	if (
		importing.email &&
		importing.address &&
		importing.displayName &&
		!current.email &&
		getFullAddress(current) === getFullAddress(importing) &&
		current.displayName === importing.displayName
	) {
		current.email = importing.email
	}

	return current
}

export const mergeImportingRecipients = (
	existingRecipients: Recipient[],
	importingRecipients: Recipient[],
) => {
	const mergedRecipients = [...existingRecipients]
	const newRecipients: Recipient[] = []

	for (const importing of importingRecipients) {
		const mergeIndex = getIndexOfRecipient(mergedRecipients, importing)
		if (mergeIndex === -1) {
			newRecipients.push(importing)
		} else {
			mergedRecipients[mergeIndex] = mergeRecipient(
				mergedRecipients[mergeIndex],
				importing,
			)
		}
	}

	return { mergedRecipients, newRecipients }
}
